import React, {FC} from 'react';
import {makeStyles} from '@material-ui/core';
import {FormNameEnum} from 'filters-selections';
import {TextAreaSelection} from '../TextAreaSelection/TextAreaSelection';
import {IWithDisabled} from 'models/common';
import {Container} from 'components-lib';
import {RESOURCE_FIELD_TOOLTIPS} from '../../../utils/tooltipConstants';

type Props = IWithDisabled;

export const AccessibilityReportsTextArea: FC<Props> = ({disabled}) => {
  const classes = useStyles();
  return (
    <Container disableGutters classes={{root: classes.root}}>
      <TextAreaSelection
        name={FormNameEnum.accessibilityReports}
        label="Accessibility Reports"
        disabled={disabled}
        rows={4}
      />
    </Container>
  );
};

export const NotesTextArea: FC<Props> = ({disabled}) => {
  const classes = useStyles();
  return (
    <Container disableGutters classes={{root: classes.root}}>
      <TextAreaSelection name={FormNameEnum.notes} label="Media Rights Notes" disabled={disabled} rows={4} />
    </Container>
  );
};

export const AlternateTextArea: FC<Props> = ({disabled}) => {
  const classes = useStyles();
  return (
    <Container disableGutters classes={{root: classes.root}}>
      <TextAreaSelection
        name={FormNameEnum.alternateText}
        label="Alt Text"
        disabled={disabled}
        rows={4}
        infoText={RESOURCE_FIELD_TOOLTIPS.altText}
      />
    </Container>
  );
};

export const KeywordsTextArea: FC<Props> = ({disabled}) => {
  const classes = useStyles();
  return (
    <Container disableGutters classes={{root: classes.root}}>
      <TextAreaSelection
        name={FormNameEnum.keyTerms}
        label="Keywords"
        disabled={disabled}
        rows={6}
        infoText={RESOURCE_FIELD_TOOLTIPS.keywords}
      />
    </Container>
  );
};

export const LearningObjectivesTextArea: FC<Props> = ({disabled}) => {
  const classes = useStyles();
  return (
    <Container disableGutters classes={{root: classes.root}}>
      <TextAreaSelection
        name={FormNameEnum.learningObjectives}
        label="Learning Objectives"
        disabled={disabled}
        rows={6}
        infoText={RESOURCE_FIELD_TOOLTIPS.learningObjectives}
      />
    </Container>
  );
};

const useStyles = makeStyles(() => ({
  root: {
    paddingBottom: '2px',
  },
}));
